import { TServerCalendarAppointmentEventDetail } from './calendar';

export enum EZoomVideoViewActionType {
    MESSAGE = 'message',
    SEND_A_REMINDER = 'sendAReminder',
    PARTICIPANTS = 'participants',
    SCHEDULE_FOLLOW_UP = 'scheduleFollowUp',
    END_CALL = 'endCall',
    CALL_IS_ENDED = 'callIsEnded',
}

export type TZoomVideoViewProps = {
    /** Zoom 后端返回的 sessionKey c2fbb227-a5cf-45ec-80ba-e911c79d4dcf */
    sessionKey?: string;
    /** 后端返回的 hostToken 或 participantToken */
    token?: string;
    /** 在 Zoom 里显示的用户名，比如 Doctor / Patient */
    userName?: string;
    mode?: 'preview' | 'call';
    role?: EMeetingUserType;
    layout?: 'default' | 'picture-in-picture' | 'float';
    videoWidth?: number;
    videoHeight?: number;
    videoDefaultOn?: boolean;
    audioDefaultOn?: boolean;
    onAction?: (actionType: EZoomVideoViewActionType) => void;
    incomeMessage?: string;
    showMaximizeButton?: boolean;
    pipVideoWidth?: number;
    pipVideoHeight?: number;
    userUuid?: string;
    hidePreviewReminderAction?: boolean;
    hideScheduleFollowUpAction?: boolean;
    endFlag?: {};
    newCommingMessage?: { name: string; value: string };
    newCommingMessageAmount?: number;
    reLayoutWhenSharing?: boolean;
    ratio?: number;
    syncAudioFlag?: {};
    startFlag?: boolean; //for get user click event
};

export enum EMeetingUserType {
    PROVIDER = 'PROVIDER',
    KLARITY_USER = 'KLARITY_USER',
}

export type TServerMeetingRoomUser = {
    id: number;
    sessionKey: string;
    userType: string;
    userId: number;
    userUuid: string;
    userCustomerFullName: string;
    firstName: string;
    lastName: string;
    credential: string;
    isHost: boolean;
    adminFlag: boolean;
    adminAt: string;
    videoRoomFirstJoinAt: string;
    videoRoomLastJoinAt: string;
    videoRoomLeaveAt: string | null;
    isVideoRoomOnline: boolean;
    waitingRoomFirstJoinAt: string;
    waitingRoomLastJoinAt: string;
    isWaitingOnline: boolean;
    isVideoOn: boolean;
    isAudioOn: boolean;
    lastRenewAt: string;
    createAt: string;
    updateAt: string;
    online: boolean;
    approvalPending: boolean;
};

// {
//     "id": 1,
//     "sessionKey": "TEST",
//     "status": "STARTED",
//     "sessionName": "Counseling & Therapy Test 02: New patient initial visit",
//     "meetingRoomUsers": [
//         {
//             "id": 1,
//             "sessionKey": "TEST",
//             "userType": "PROVIDER",
//             "userId": 1287,
//             "userUuid": "6ecc4a9aedf5420aa3a396c147778ab4",
//             "videoRoomActiveUserUuid": "",
//             "userCustomerFullName": "xxx",
//             "firstName": "autocharge",
//             "lastName": "Test",
//             "credential": "LAADC-CA,ACNP,ACCNS-P",
//             "isHost": true,
//             "adminFlag": true,
//             "adminAt": "2025-12-08T08:42:12Z",
//             "videoRoomFirstJoinAt": "2025-12-08T08:42:12Z",
//             "videoRoomLastJoinAt": "2025-12-08T08:42:12Z",
//             "videoRoomLeaveAt": null,
//             "isVideoRoomOnline": false,
//             "waitingRoomFirstJoinAt": "2025-12-08T08:39:12Z",
//             "waitingRoomLastJoinAt": "2025-12-08T08:39:12Z",
//             "isWaitingOnline": false,
//             "isVideoOn": false,
//             "isAudioOn": false,
//             "lastRenewAt": "2025-12-08T08:43:41Z",
//             "createAt": "2025-12-08T08:39:12Z",
//             "updateAt": "2025-12-08T09:30:00Z",
//             "online": false,
//             "approvalPending": false
//         },
//         {
//             "id": 2,
//             "sessionKey": "test",
//             "userType": "PROVIDER",
//             "userId": 1287,
//             "userUuid": "6128c0fceded4783aa31aa805cff2f5f",
//             "videoRoomActiveUserUuid": "",
//             "userCustomerFullName": "",
//             "firstName": "autocharge",
//             "lastName": "Test",
//             "credential": "LAADC-CA,ACNP,ACCNS-P",
//             "isHost": true,
//             "adminFlag": false,
//             "adminAt": null,
//             "videoRoomFirstJoinAt": null,
//             "videoRoomLastJoinAt": null,
//             "videoRoomLeaveAt": null,
//             "isVideoRoomOnline": false,
//             "waitingRoomFirstJoinAt": "2025-12-08T13:16:53Z",
//             "waitingRoomLastJoinAt": "2025-12-08T13:16:53Z",
//             "isWaitingOnline": true,
//             "isVideoOn": false,
//             "isAudioOn": false,
//             "lastRenewAt": "2025-12-08T13:16:53Z",
//             "createAt": "2025-12-08T13:16:53Z",
//             "updateAt": "2025-12-08T13:16:53Z",
//             "online": true,
//             "approvalPending": false
//         },
//         {
//             "id": 3,
//             "sessionKey": "test",
//             "userType": "PROVIDER",
//             "userId": 1287,
//             "userUuid": "dd265b6e291f4d30a23c1567ab9d1a8e",
//             "videoRoomActiveUserUuid": "",
//             "userCustomerFullName": "",
//             "firstName": "autocharge",
//             "lastName": "Test",
//             "credential": "LAADC-CA,ACNP,ACCNS-P",
//             "isHost": true,
//             "adminFlag": false,
//             "adminAt": null,
//             "videoRoomFirstJoinAt": null,
//             "videoRoomLastJoinAt": null,
//             "videoRoomLeaveAt": null,
//             "isVideoRoomOnline": false,
//             "waitingRoomFirstJoinAt": "2025-12-08T13:16:57Z",
//             "waitingRoomLastJoinAt": "2025-12-08T13:16:57Z",
//             "isWaitingOnline": true,
//             "isVideoOn": false,
//             "isAudioOn": false,
//             "lastRenewAt": "2025-12-08T13:16:57Z",
//             "createAt": "2025-12-08T13:16:57Z",
//             "updateAt": "2025-12-08T13:16:57Z",
//             "online": true,
//             "approvalPending": false
//         }
//     ],
//     "appointmentDetail": {
//         "id": 2003,
//         "appointmentName": "Counseling & Therapy Test 02: New patient initial visit",
//         "providerId": 1287,
//         "clientId": 106666,
//         "startAt": "2025-12-06T02:48:08Z",
//         "endAt": "2025-12-13T11:09:18Z",
//         "duration": 10,
//         "contactType": "video",
//         "appointmentStatus": "scheduled",
//         "appointmentStatusChangedAt": null,
//         "externalVideoLink": "",
//         "notes": "",
//         "reason": "Hi autocharge Test,\nI'm looking for a Counseling & Therapy visit. I'd like your help to see me to help me feel better. Thank you.",
//         "scheduledBy": "klarity-booked",
//         "serviceType": "New patient initial visit",
//         "serviceSpecialty": "Counseling & Therapy",
//         "serviceState": "CA",
//         "serviceId": 751,
//         "location": null,
//         "telephone": "",
//         "isSample": false,
//         "createdAt": "2025-12-01T02:44:56Z"
//     },
//     "zoomSessionToken": null,
//     "zoomSessionTokenExpireAt": null,
//     "currentUserId": 1287,
//     "currentUserType": "PROVIDER",
//     "currentUserUuid": "dd265b6e291f4d30a23c1567ab9d1a8e"
// }

export type TServerRoomInfo = {
    videoRoomStartAt: string; // "2025-12-08T08:42:12Z",
    id: number;
    sessionKey: string;
    status: string;
    sessionName: string;
    meetingRoomUsers: TServerMeetingRoomUser[];
    appointmentDetail: TServerCalendarAppointmentEventDetail;
    zoomSessionToken: string | null;
    zoomSessionTokenExpireAt: string | null;
    currentUserId: number;
    currentUserType: EMeetingUserType;
    currentUserUuid: string;
};

export type TDeviceInfo = {
    deviceId: string;
    groupId?: string;
    label: string;
    isDefault: boolean;
};

export enum EZoomErrorType {
    PERMISSION_NOT_ALLOW = 'permissionNotAllow',
    START_AUDIO = 'startAudio',
    START_VIDEO = 'startVideo',
    STOP_AUDIO = 'stopAudio',
    STOP_VIDEO = 'stopVideo',
    JOIN_CALL = 'joinCall',
    MUTE_AUDIO = 'muteAudio',
    UNMUTE_AUDIO = 'unmuteAudio',
}
